import {
  EarningsInsightType,
  IconDisplayRule,
  SummaryInsightType,
} from '@toggle/toggle';
import { t } from 'i18next';

export type InsightsPeriod = {
  duration: number;
  unit: string;
};

export const DEFAULT_WHATS_NEW_PERIOD: InsightsPeriod = {
  duration: 1,
  unit: 'day',
};

export const getAnalysisTypes = (): {
  id: NonNullable<IconDisplayRule>;
  title: string;
}[] => [
  { id: 'fundamentals', title: t('whatsNew:fundamentals') },
  { id: 'technicals', title: t('whatsNew:technicals') },
  { id: 'macroeconomics', title: t('whatsNew:macro') },
];

export const getEarningsTypes = (): {
  id: NonNullable<EarningsInsightType>;
  title: string;
}[] => [
  { id: 'preview', title: t('whatsNew:previews') },
  { id: 'recap', title: t('whatsNew:recaps') },
];

export const getSummariesTypes = (): {
  id: NonNullable<SummaryInsightType>;
  title: string;
}[] => [{ id: 'market', title: t('whatsNew:market') }];
